var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "addOrderRowDialog",
      attrs: {
        title: "新增明细",
        visible: _vm.isShowaddOutsourcedOrderRowDialog,
        width: "80%",
        "show-close": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        top: "4vh",
        "lock-scroll": "",
        "destroy-on-close": true,
        "before-close": _vm.handleCancel
      },
      on: {
        "update:visible": function($event) {
          _vm.isShowaddOutsourcedOrderRowDialog = $event
        },
        close: _vm.handleCancel
      }
    },
    [
      _c("div", { staticClass: "body" }, [
        _c(
          "div",
          { staticClass: "topToolBar" },
          [
            _c(
              "el-select",
              {
                attrs: { placeholder: "" },
                on: { change: _vm.handelChangeKeyType },
                model: {
                  value: _vm.keyName,
                  callback: function($$v) {
                    _vm.keyName = $$v
                  },
                  expression: "keyName"
                }
              },
              _vm._l(_vm.keyList, function(item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value }
                })
              }),
              1
            ),
            _c("el-input", {
              staticStyle: { "margin-right": "10px" },
              attrs: { placeholder: "按回车键查询数据" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm._getErpPOlist.apply(null, arguments)
                }
              },
              model: {
                value: _vm.keyCode,
                callback: function($$v) {
                  _vm.keyCode = $$v
                },
                expression: "keyCode"
              }
            }),
            _c(
              "el-button",
              {
                staticClass: "searchButton",
                attrs: { type: "primary", size: "small" },
                on: { click: _vm._getErpPOlist }
              },
              [_vm._v("搜索")]
            ),
            _c(
              "el-button",
              {
                staticClass: "outputButton",
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.handleInputClear }
              },
              [_vm._v("清除")]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass: "table-wrap"
          },
          [
            _c(
              "vxe-table",
              {
                ref: "xTable",
                attrs: {
                  align: "center",
                  border: "",
                  data: _vm.tabelData,
                  "column-config": _vm.columnConfig,
                  "row-config": { isHover: true, height: 55 },
                  size: "small",
                  stripe: "",
                  height: "100%",
                  "row-class-name": _vm.rowClassName,
                  "checkbox-config": {
                    highlight: true,
                    checkMethod: _vm.checCheckboxkMethod
                  },
                  "show-overflow": "ellipsis"
                },
                on: {
                  "cell-click": _vm.currentChange,
                  "checkbox-change": _vm.currentChange
                }
              },
              [
                _c("vxe-table-column", {
                  attrs: { type: "checkbox", width: "60", fixed: "left" }
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "BILL_NO",
                    title: "单据编号",
                    width: "150",
                    fixed: "left"
                  }
                }),
                _c("vxe-column", {
                  attrs: { field: "BILL_ITEM", width: "90", title: "采购项ID" }
                }),
                _c("vxe-column", {
                  attrs: { field: "PO_LINE", width: "90", title: "采购单行号" }
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "VENDOR_CODE",
                    width: "120",
                    title: "供应商编号"
                  }
                }),
                _c("vxe-column", {
                  attrs: { field: "PART_NO", width: "120", title: "物料编码" }
                }),
                _c("vxe-column", {
                  attrs: { field: "BILL_TYPE", width: "130", title: "单据类型" }
                }),
                _c("vxe-column", {
                  attrs: { field: "PART_NAME", width: "130", title: "物料名称" }
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "PART_DESCR",
                    width: "120",
                    title: "规格描述"
                  }
                }),
                _c("vxe-column", {
                  attrs: { field: "CASE_QTY", width: "90", title: "最小包装" }
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "BOX_QTY",
                    width: "150",
                    title: "装箱单位数量"
                  }
                }),
                _c("vxe-column", {
                  attrs: { field: "QTY", width: "150", title: "数量" }
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "SCMCreateOrder_QTY",
                    width: "150",
                    title: "建单数量"
                  }
                }),
                _c("vxe-column", {
                  attrs: { field: "SCM_QTY", width: "150", title: "在途数量" }
                }),
                _c("vxe-column", {
                  attrs: { field: "IQC_QTY", width: "150", title: "待检数量" }
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "RECEIVED_QTY",
                    width: "150",
                    title: "已收数量"
                  }
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "REMAINING_QTY",
                    width: "150",
                    title: "可交数量"
                  }
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "CREATETIME",
                    width: "150",
                    title: "订单创建时间"
                  }
                }),
                _c("vxe-column", {
                  attrs: { field: "BASE_UNIT", width: "150", title: "基本单位" }
                }),
                _c("vxe-column", {
                  attrs: { field: "UNIT_CODE", width: "150", title: "单位编码" }
                }),
                _c("vxe-column", {
                  attrs: { field: "PO_UNIT", width: "150", title: "采购单位" }
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "UNIT_EXRATE",
                    width: "150",
                    title: "转换比例"
                  }
                }),
                _c("vxe-column", {
                  attrs: { field: "PURCHASER", width: "150", title: "采购员" }
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "PURCHASER_CODE",
                    width: "150",
                    title: "采购员编码"
                  }
                }),
                _c("vxe-column", {
                  attrs: { field: "WAREHOUSE", width: "150", title: "仓库编码" }
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "WAREHOUSE_NAME",
                    width: "150",
                    title: "仓库"
                  }
                }),
                _c("vxe-column", {
                  attrs: { field: "FNote", width: "150", title: "备注" }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "el-dialog__footer" }, [
        _c(
          "div",
          {
            staticClass: "dialog-footer-cancle",
            on: { click: _vm.handleCancel }
          },
          [_vm._v("取 消")]
        ),
        _c(
          "div",
          {
            staticClass: "dialog-footer-submit",
            on: { click: _vm.handleDelSubmit }
          },
          [_vm._v("确 定")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }